import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=67efd71a"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67efd71a')) {
      api.createRecord('67efd71a', component.options)
    } else {
      api.reload('67efd71a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=67efd71a", function () {
      api.rerender('67efd71a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/org/Index.vue"
export default component.exports